import { render, staticRenderFns } from "./r-item-dialog.vue?vue&type=template&id=d9cc8874&scoped=true"
import script from "./r-item-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-dialog.vue?vue&type=style&index=0&id=d9cc8874&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cc8874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9cc8874')) {
      api.createRecord('d9cc8874', component.options)
    } else {
      api.reload('d9cc8874', component.options)
    }
    module.hot.accept("./r-item-dialog.vue?vue&type=template&id=d9cc8874&scoped=true", function () {
      api.rerender('d9cc8874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-dialog.vue"
export default component.exports